export function buildTeamNameIndexKey(eventId, venueRole) {
    return `${eventId}${venueRole}`;
}
//# sourceMappingURL=buildTeamNameIndexKey.js.map